import { useMemo } from "react"
import { Data } from "../../../../../features/data-types"
import { Table, Section, Column, FieldType, FieldValue } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useTaxLoaders } from "../../../loaders/taxLoaders"

type Props = {
    taxItems: Data[]
    readOnly?: boolean
    disableCreate?: boolean
    active?: boolean
    onCreate?: () => void
    onEditRow?: (taxCode: string) => void
    onRemoveRow?: (taxCode: string) => void
}

export const TaxItemsTable = (props: Props) => {
    const { taxItems, readOnly, disableCreate, active, onCreate, onEditRow, onRemoveRow } = props

    const taxLoaders = useTaxLoaders()
    
    const taxes = useMemo(() => taxLoaders().findAllTaxes(active), [])

    const columns: Column[] = [
        {
            name: 'taxCode',
            type: FieldType.TABLE,
            table: TableName.TAXES,
            label: 'Impuesto',
            render: (value?: FieldValue) => taxLoaders().findTaxByCode(value as string)!.name
        },
        {
            name: 'taxYield',
            type: FieldType.PERCENTAGE,
            label: '%'
        },
        {
            name: 'amount',
            type: FieldType.PRICE,
            label: 'Monto'
        }
    ]

    return (
        <Section
            id='taxItems'
            space={12}
        >
            <Table
                columns={columns}
                rows={taxItems}
                rowId='taxCode'
                readOnly={readOnly}
                createIcon="plus"
                disableCreate={disableCreate || taxItems.length >= taxes.length}
                small
                onCreate={onCreate}
                onEdit={onEditRow}
                onRemove={onRemoveRow}
            />
        </Section>
    )
}
